import React, { useEffect, useState } from 'react';
import Pagetitle from './component/Pagetitle';
import MyAccountNav from './component/MyAccountNav';
import { useLocation, useNavigate } from 'react-router-dom';
import { useApiStore } from './hooks/ApiStoreContext';
import dateFormat from "dateformat";
import "./MyAccountOrderDetails.css";

function MyAccountOrderDetails() {

    const location = useLocation();
    const navigate = useNavigate();
    const apiStore = useApiStore();
    //const [orderId, setOrderId] = useState(0);
    const [orderStatus, setOrderStatus] = useState([]);
    const [paymentStatus, setPaymentStatus] = useState([]);
    const [orderDetails, setOrderDetails] = useState({});
    const [userDetail, setUserDetail] = useState({});
    const [deliveryAddressDetail, setDeliveryAddressDetail] = useState({});
    const [billingAddressDetail, setBillingAddressDetail] = useState({});
    const [productDetail, setProductDetail] = useState([]);

    useEffect(() => {
        let id = parseInt(location.pathname.split("/")[2]);
        
        async function bindData() {
            try {
                const ps = await getPaymentStatusList();
                const os = await getOrderStatusList();
                const finalResult = await getOrderDetailsById(os, id);
            } catch (error) {
                console.error("Error:", error);
            }
        }

        bindData();

    }, [location]);

    async function getOrderStatusList() {
        return new Promise(async (resolve) => {
            try {
                const response = await apiStore.get("/order/GetOrderStatusList");
                setOrderStatus(response);
                console.log("First async function completed");
                resolve(response);
            } catch (error) {
                if (error.response.status !== 401) {
                    console.error("There was an error fetching orders status list!", error);
                }
            }
        });
    }

    async function getPaymentStatusList() {
        return new Promise(async (resolve) => {
            try {
                const response = await apiStore.get("/order/GetPaymentStatusList");
                setPaymentStatus(response);
                resolve(response);
            } catch (error) {
                if (error.response.status !== 401) {
                    console.error("There was an error fetching payment status list!", error);
                }
            }
        });
    }

    async function getOrderDetailsById(data, orderId) {
        return new Promise(async (resolve) => {
            try {
                const response = await apiStore.get(`/order/${orderId}`);
                console.log("Second async function completed with:", data);

                setOrderDetails(response);
                setUserDetail(response.user);
                setDeliveryAddressDetail(response.deliveryAddress);
                setBillingAddressDetail(response.billingAddress);
                setProductDetail(response.orderItems);
                resolve(response);
            } catch (error) {
                if (error.response.status !== 401) {
                    console.error("There was an error fetching order details!", error);
                }
            }
        });
    }

    // Function to handle order cancellation
    async function handleCancelOrder() {
        if (window.confirm('Are you sure you want to cancel this order?')) {
            try {
                // Replace with your actual API endpoint for canceling an order

                const response = await apiStore.put(`/order/updateOrderStatus/${orderDetails.orderId}/5`);
                
                // Refresh order details after cancellation
                const updatedOrder = await getOrderDetailsById(orderStatus, orderDetails.orderId);
                alert('Order canceled successfully!');
            } catch (error) {
                console.error('Error cancelling order:', error);
                alert('Failed to cancel order. Please try again.');
            }
        }
    }

    // Determine if the order is cancelable
    const isCancelable = orderStatus.find(os => os.id === orderDetails.orderStatus)?.name === "Order Placed" ||
                         orderStatus.find(os => os.id === orderDetails.orderStatus)?.name === "Processing";

    return (

        <>
            <Pagetitle title="My Orders" />
            <section className="flat-spacing-11">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-3">
                            <MyAccountNav activeLink="orders" />
                        </div>
                        <div className="col-lg-9">
                            <div className="wd-form-order">
                                <div className="order-head">
                                    {/* <figure className="img-product">
                                        <img src={"/images/products/brown.jpg" }alt="product" />
                                    </figure> */}
                                    <div className="content">
                                        <div className={orderDetails.orderStatus==4?"badge text-bg-success":"badge"}>{orderStatus.find(os => os.id === orderDetails.orderStatus)?.name}</div>
                                        <h6 className="mt-8 fw-5">Order #{orderDetails.orderId}</h6>

                                        <div></div>
                                        {/* Cancel Order Button */}
                                        <button
                                            className="btn btn-secondary cancel-order-btn"
                                            onClick={handleCancelOrder}
                                            disabled={!isCancelable}
                                        >
                                            Cancel Order
                                        </button>
                                    </div>
                                </div>
                                <div className="tf-grid-layout md-col-2 gap-15">
                                    <div className="item">
                                        <div className="text-2 text_black-2">Company Name</div>
                                        <div className="text-2 mt_4 fw-6">{userDetail.firstName}</div>
                                    </div>
                                    <div className="item">
                                        <div className="text-2 text_black-2">Contact Person</div>
                                        <div className="text-2 mt_4 fw-6">{userDetail.lastName}</div>
                                    </div>
                                    <div className="item">
                                        <div className="text-2 text_black-2">Payment Status</div>
                                        <div className="text-2 mt_4 fw-6"><span className={orderDetails.paymentStatus==2?"badge text-bg-success":'badge'}>{paymentStatus.find(ps => ps.id === orderDetails.paymentStatus)?.name}</span></div>
                                    </div>
                                    <div className="item">
                                        <div className="text-2 text_black-2">Order Date</div>
                                        <div className="text-2 mt_4 fw-6">{dateFormat(orderDetails.orderDate, "dd mmm yyyy HH:MM")}</div>
                                    </div>
                                    <div className="item">
                                        <div className="text-2 text_black-2">Delivery Address</div>
                                        <div className="text-2 mt_4 fw-6">{"Company Name: " + deliveryAddressDetail.name}</div>
                                        <div className="text-2 mt_4 fw-6">{"Contact Person: " + deliveryAddressDetail.contactPerson}</div>
                                        <div className="text-2 mt_4 fw-6">{"GST Number: " + deliveryAddressDetail.gstNumber}</div>
                                        <div className="text-2 mt_4 fw-6">{"Address: " + deliveryAddressDetail.addressLine1 + ", " + deliveryAddressDetail.addressLine2 + ", " + deliveryAddressDetail.city}</div>
                                        <div className="text-2 mt_4 fw-6">{deliveryAddressDetail.state + ", " + deliveryAddressDetail.country}</div>
                                        <div className="text-2 mt_4 fw-6">{"Pincode: " + deliveryAddressDetail.zipCode}</div>
                                        <div className="text-2 mt_4 fw-6">{"Mobile No: " + deliveryAddressDetail.phoneNumber}</div>
                                        <div className="text-2 mt_4 fw-6">{"Transport: " + deliveryAddressDetail.transport}</div>
                                    </div>
                                    <div className="item">
                                        <div className="text-2 text_black-2">Billing Address</div>
                                        <div className="text-2 mt_4 fw-6">{"Company Name: " + billingAddressDetail.name}</div>
                                        <div className="text-2 mt_4 fw-6">{"Contact Person: " + billingAddressDetail.contactPerson}</div>
                                        <div className="text-2 mt_4 fw-6">{"GST Number: " + billingAddressDetail.gstNumber}</div>
                                        <div className="text-2 mt_4 fw-6">{"Address" + billingAddressDetail.addressLine1 + ", " + billingAddressDetail.addressLine2 + ", " + billingAddressDetail.city}</div>
                                        <div className="text-2 mt_4 fw-6">{billingAddressDetail.state + ", " + billingAddressDetail.country}</div>
                                        <div className="text-2 mt_4 fw-6">{"Pincode: " + billingAddressDetail.zipCode}</div>
                                        <div className="text-2 mt_4 fw-6">{"Mobile No: " + billingAddressDetail.phoneNumber}</div>
                                        <div className="text-2 mt_4 fw-6">{"Transport: " + billingAddressDetail.transport}</div>
                                    </div>
                                    
                                </div>
                                <div className="widget-tabs style-has-border widget-order-tab">
                                    <ul className="widget-menu-tab">
                                        <li className="item-title active">
                                            <span className="inner">Order History</span>
                                        </li>
                                        <li className="item-title">
                                            <span className="inner">Item Details</span>
                                        </li>
                                        {/* <li className="item-title">
                                            <span className="inner">Courier</span>
                                        </li>
                                        <li className="item-title">
                                            <span className="inner">Receiver</span>
                                        </li> */}
                                    </ul>
                                    <div className="widget-content-tab">
                                        <div className="widget-content-inner active">
                                            <div className="widget-timeline">
                                                <ul className="timeline">
                                                    {
                                                        orderStatus.map((o) => (
                                                            <li key={o.id}>
                                                                <div className={o.id <= orderDetails.orderStatus ? "timeline-badge success" : "timeline-badge"}></div>
                                                                <div className="timeline-box">
                                                                    <a className="timeline-panel">
                                                                        <div className="text-2 fw-6">{o.name}</div>
                                                                    </a>
                                                                </div>
                                                            </li>
                                                        ))
                                                    }
                                                    {/* <li>
                                                        <div className="timeline-badge success"></div>
                                                        <div className="timeline-box">
                                                            <a className="timeline-panel" href="javascript:void(0);">
                                                                <div className="text-2 fw-6">Product Shipped</div>
                                                                <span>10/07/2024 4:30pm</span>
                                                            </a>
                                                            <p><strong>Courier Service : </strong>FedEx World Service Center
                                                            </p>
                                                            <p><strong>Estimated Delivery Date : </strong>12/07/2024</p>
                                                        </div>
                                                    </li>
                                                    <li>
                                                        <div className="timeline-badge success"></div>
                                                        <div className="timeline-box">
                                                            <a className="timeline-panel" href="javascript:void(0);">
                                                                <div className="text-2 fw-6">Product Shipped</div>
                                                                <span>10/07/2024 4:30pm</span>
                                                            </a>
                                                            <p><strong>Tracking Number : </strong>2307-3215-6759</p>
                                                            <p><strong>Warehouse : </strong>T-Shirt 10b</p>
                                                        </div>
                                                    </li>
                                                    <li>
                                                        <div className="timeline-badge"></div>
                                                        <div className="timeline-box">
                                                            <a className="timeline-panel" href="javascript:void(0);">
                                                                <div className="text-2 fw-6">Product Packaging</div>
                                                                <span>12/07/2024 4:34pm</span>
                                                            </a>
                                                        </div>
                                                    </li>
                                                    <li>
                                                        <div className="timeline-badge"></div>
                                                        <div className="timeline-box">
                                                            <a className="timeline-panel" href="javascript:void(0);">
                                                                <div className="text-2 fw-6">Order Placed</div>
                                                                <span>11/07/2024 2:36pm</span>
                                                            </a>
                                                        </div>
                                                    </li> */}
                                                </ul>
                                            </div>
                                        </div>
                                        <div className="widget-content-inner">
                                            {
                                                productDetail.map((o) => (
                                                    <div key={o.orderItemId} className="order-head">
                                                        <figure className="img-product">
                                                            <img src={"/" + o.product.productImages[0].imageSource} alt="product" />
                                                        </figure>
                                                        <div className="content">
                                                            <div className="text-2 fw-6">{o.product.name}</div>
                                                            <div className="mt_4"><span className="fw-6">Quantity :</span> {o.quantity}</div>
                                                            <div className="mt_4"><span className="fw-6">Total Price :</span> {o.priceAfterDiscount * o.quantity}</div>
                                                        </div>
                                                    </div>
                                                ))
                                            }

                                            <ul>
                                                <li className="d-flex justify-content-between text-2">
                                                    <span>Sub Total</span>
                                                    <span className="fw-6">₹ {orderDetails.subTotal}</span>
                                                </li>
                                                <li className="d-flex justify-content-between text-2 mt_4">
                                                    <span style={{ fontStyle: "italic", color: "green" }}>Discount</span>
                                                    <span className="fw-6" style={{ color: "green" }}>- ₹ {orderDetails.subTotal - (orderDetails.totalAmount - orderDetails.gstAmount)}</span>
                                                </li>
                                                <li className="d-flex justify-content-between text-2 mt_4 pb_8 line">
                                                    <span style={{ fontStyle: "italic" }}>GST</span>
                                                    <span className="fw-6">+ ₹ {orderDetails.gstAmount}</span>
                                                </li>
                                                <li className="d-flex justify-content-between text-2 mt_8">
                                                    <span>Order Total</span>
                                                    <span className="fw-6">₹ {orderDetails.totalAmount}</span>
                                                </li>
                                            </ul>
                                        </div>
                                        {/* <div className="widget-content-inner">
                                            <p>Our courier service is dedicated to providing fast, reliable, and secure
                                                delivery solutions tailored to meet your needs. Whether you're sending
                                                documents, parcels, or larger shipments, our team ensures that your items
                                                are handled with the utmost care and delivered on time. With a commitment to
                                                customer satisfaction, real-time tracking, and a wide network of routes, we
                                                make it easy for you to send and receive packages both locally and
                                                internationally. Choose our service for a seamless and efficient delivery
                                                experience.</p>
                                        </div>
                                        <div className="widget-content-inner">
                                            <p className="text-2 text_success">Thank you Your order has been received</p>
                                            <ul className="mt_20">
                                                <li>Order Number : <span className="fw-7">#17493</span></li>
                                                <li>Date : <span className="fw-7"> 17/07/2024, 02:34pm</span></li>
                                                <li>Total : <span className="fw-7">$18.95</span></li>
                                                <li>Payment Methods : <span className="fw-7">Cash on Delivery</span></li>

                                            </ul>
                                        </div> */}

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default MyAccountOrderDetails